export const sanitizePhoneNumber = (phoneNumber: string): string => {
  let sanitizedNumber = phoneNumber.replace(/[^0-9*+# ]/g, "")

  sanitizedNumber = sanitizedNumber.replace(/\s/g, "")

  return sanitizedNumber
}
